import axios from "axios";

const API = axios.create({
   baseURL: "/api",
  withCredentials: true   // 🔥 very important
});

export default API;
